import React, {useState} from "react";
import {PageHeader} from "../../../../components/PageHeader";
import AssetLeaseListType from "./subPages/AssetLeaseListType";
import {toKSTISOString, toKSTISOStringEnd} from "../../../../components/commonmethod/CommonMethod";
import {addYears} from "date-fns";
import useRequestData from "../../../../hooks/useRequestData";
import {getLeaseList} from "../../../../api/asset/AssetLeaseService";

function AssetLeaseList() {
    const [checked,setChecked] = useState([]);

    const initDate ={
        startDate:toKSTISOString(addYears(new Date(),-1)),
        endDate:toKSTISOStringEnd(addYears(new Date(),0)),
    }

    const { newData, pageInfo, dataHook} = useRequestData(getLeaseList, initDate, "lease");

    return (
        <>
            <div className="common-container">
                <PageHeader header={"자산리스관리"} indicator={"자산관리 > 자산재무관리 > 자산리스관리"} />
                <AssetLeaseListType
                    data={newData} date={initDate} pageInfo={pageInfo}
                    dataHook={dataHook}
                    checked={{checked: checked, setChecked: setChecked}} />
            </div>
        </>
    );
}

export default AssetLeaseList;